import { MatchQuality } from '@upright/common/model/search/match-quality';
import { ModelEntitySearchResponseItem } from '@upright/common/model/search/types';
import { MenuListProps } from 'react-select';
import styled from 'styled-components';
import { BouColor } from '../../../../../generic/global/bou-colors';
import { matchConfidenceBannerMessage } from './match-confidence-banner-message';

export function CustomMenuList<IsMulti extends boolean>(props: MenuListProps<ModelEntitySearchResponseItem, IsMulti>) {
  return (
    <MenuRoot>
      <MenuMain>
        <div>{props.children}</div>
      </MenuMain>
    </MenuRoot>
  );
}

/**
 * Menu-list variant that prepends a match-confidence banner when the top hit is
 * not a clean, confident match (see `computeMatchQuality` /
 * `matchConfidenceBannerMessage`). Used only by search boxes that opt into
 * match-confidence checking (the self-serve portfolio picker), so a weak fuzzy
 * match or a same-named twin is flagged instead of being presented as if it were
 * a confident hit. Results stay visible below the banner so a user who knows the
 * right entity is not blocked.
 */
export function getMatchConfidenceMenuList(matchQuality: MatchQuality | undefined) {
  const bannerMessage = matchConfidenceBannerMessage(matchQuality);
  return function MatchConfidenceMenuList<IsMulti extends boolean>(
    props: MenuListProps<ModelEntitySearchResponseItem, IsMulti>,
  ) {
    return (
      <MenuRoot>
        <MenuMain>
          {bannerMessage !== null && <MatchConfidenceBanner>{bannerMessage}</MatchConfidenceBanner>}
          <div>{props.children}</div>
        </MenuMain>
      </MenuRoot>
    );
  };
}

const MenuRoot = styled.div``;

const MenuMain = styled.div`
  padding-top: 6px;
  padding-bottom: 6px;
`;

const MatchConfidenceBanner = styled.div`
  margin: 0 16px 6px;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: ${BouColor.PLATFORM_BG_GRAY_LIGHT};
  color: ${BouColor.PLATFORM_TEXT_GRAY};
  font-weight: normal;
  font-size: 0.85em;
  line-height: 1.3;
  white-space: normal;
`;
